import { Injectable } from '@angular/core';
import {
    MatSnackBar,
    MatSnackBarConfig,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { SnackBarDefaultConfig as Config } from '../enums/snackBar.enum';
import { concatMap, of, Subject, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export abstract class UniversalSnackbarService {
    private displaySnackBar = new Subject<{
        message: string;
        configuration: MatSnackBarConfig;
    }>();

    constructor(private snackBar: MatSnackBar) {
        this.displaySnackBar
            .pipe(
                concatMap(({ message, configuration }) =>
                    this.getSnackBarDelay().pipe(
                        tap(() =>
                            this.snackBar.open(
                                message,
                                Config.ACTION,
                                configuration,
                            ),
                        ),
                    ),
                ),
            )
            .subscribe();
    }

    private getSnackBarDelay() {
        const snackbarRef = this.snackBar._openedSnackBarRef;
        if (!!snackbarRef) {
            return snackbarRef!.afterDismissed();
        } else {
            return of({});
        }
    }

    public open(
        message: string,
        verticalPosition: MatSnackBarVerticalPosition = Config.VERTICAL_POSITION,
        horizontalPosition: MatSnackBarHorizontalPosition = Config.HORIZONTAL_POSITION,
    ): void {
        const configuration: MatSnackBarConfig = {
            duration: Config.DURATION as number, // For some reason, typescript doesn't recongnize enum member numbers as valid numbers? Type cast required
            verticalPosition: verticalPosition,
            horizontalPosition: horizontalPosition,
        };

        this.displaySnackBar.next({ message, configuration: configuration });
    }
}
